import {createTrigger, Trigger} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store} from '@gongxigames/framework/core';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {UIModuleV2} from '@gongxigames/framework/slotV2/baseClasses/uiModuleV2/UiModuleV2';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {$MainUi} from './components/UIDefault';
import {BetChangeActionData} from './components/BetSelect';
import {Container} from 'pixi.js';
import {uiAutoplayOptionsStore} from '@gongxigames/framework/slotV2/ui/services/UIAutoplayOptions/uiAutoplayOptionsStore';
import {ReelsSpeedLevel} from '@gongxigames/framework/slotV2/types';
import {specialInfoZoneStore} from '@gongxigames/framework/slotV2/services/SpecialInfoZone/specialInfoZoneStore';
import type {EventDataWinMeterCountUp, EventDataWinMeterSetValue, EventDataWinMeterShowingFinalValue} from '@gongxigames/framework/slotV2/types';

export class UIMainScreenModule extends UIModuleV2 {
    static NAME = 'UIMainScreenModule';
    public static layer = LAYERS.KEYPAD;

    container = new Container();

    private winMeterCountUp: Trigger<EventDataWinMeterCountUp> = createTrigger();
    private winMeterStopAfterShowingFinalValue: Trigger<EventDataWinMeterShowingFinalValue> = createTrigger();
    private winMeterStopFinalValueTimer: Trigger = createTrigger();
    private winMeterSetValue: Trigger<EventDataWinMeterSetValue> = createTrigger();
    private winMeterSnapToFinalValue: Trigger = createTrigger();
    private winMeterStop: Trigger = createTrigger();

    onInit(): void {
        const soundEnabled = Store.computed(() => !slotStore.slot_soundMuted.value);

        const uiDefault = $MainUi({
            jurisdictionZoneHeight: specialInfoZoneStore.blackPanelHeight,
            betList: slotStore.slot_betList,
            betCurrent: slotStore.slot_bet,
            betFormatted: slotStore.slot_betFormatted,
            balance: slotStore.slot_ui_label_balance,
            turboLevel: slotStore.reelsSpeedLevel,
            soundEnabled,

            onMenuBtn: createTrigger(this.onButtonMenu.bind(this)),
            onBetChangeBtn: this.onBetChange.bind(this),
            onShowBetSelectBtn: createTrigger(this.onShowBetSelect.bind(this)),
            onTurboBtn: this.onTurboBtn.bind(this),
            onSoundBtn: this.onButtonSound.bind(this),

            // winMeterCountUp: this.winMeterCountUp,
            // winMeterStopAfterShowingFinalValue: this.winMeterStopAfterShowingFinalValue,
            // winMeterStopFinalValueTimer: this.winMeterStopFinalValueTimer,
            // winMeterSetValue: this.winMeterSetValue,
            // winMeterSnapToFinalValue: this.winMeterSnapToFinalValue,
            // winMeterStop: this.winMeterStop,
        }) as Container;

        this.container.addChild(uiDefault);
    }

    onSetupEvents(): void {
        this.emitter.on('Game.command.WinMeter.COUNT_UP', this.winMeterCountUp );
        this.emitter.on('Game.command.WinMeter.STOP_AFTER_SHOWING_FINAL_VALUE', this.winMeterStopAfterShowingFinalValue);
        this.emitter.on('Game.command.WinMeter.STOP_FINAL_VALUE_TIMER', this.winMeterStopFinalValueTimer);
        this.emitter.on('Game.command.WinMeter.SET_VALUE', this.winMeterSetValue);
        this.emitter.on('Game.command.WinMeter.SNAP_TO_FINAL_VALUE', this.winMeterSnapToFinalValue);
        this.emitter.on('Game.command.WinMeter.STOP', this.winMeterStop);
    }

    private onButtonSound() {
        this.emitter.emit('UI.sounds.toggle');
    }

    private onButtonMenu() {
        uiAutoplayOptionsStore.showOptionsPopup.value = !uiAutoplayOptionsStore.showOptionsPopup.value;
    }

    private onBetChange(action: BetChangeActionData): void {
        if (action === '+') {
            this.emitter.emit('UI.bet.increase');
            slotStore.soundPlayer.value?.play('betbuttonup');
        } else {
            this.emitter.emit('UI.bet.decrease');
            slotStore.soundPlayer.value?.play('betbuttondown');
        }
    }

    private onShowBetSelect() {

    }

    private onTurboBtn() {
        this.emitter.emit('UI.turboBtn.pressed');

        const nextSpeedLevel = slotStore.reelsSpeedLevel.peek();
        const soundName = nextSpeedLevel === ReelsSpeedLevel.normal ? 'turbooff' : 'turboon';

        slotStore.soundPlayer.value?.play(soundName);
    }
}